// UDWW — EXPANSIVE EDITING. READING STATE = compact card; WRITING STATE = the unit opens up where it lives: the
// textarea takes the unit's full width, starts at a useful height, grows with the text, and only scrolls inside
// itself past a sensible maximum (a share of the viewport). Pure DOM sizing; no layout state.
export const EDIT_MIN_PX = 140;      // editing a unit's wording on the map
export const COMPOSE_MIN_PX = 220;   // composing the part for a reader
export const MAX_VIEWPORT_SHARE = 0.6;

export function maxGrowPx(minPx = EDIT_MIN_PX, viewportH = (typeof window !== "undefined" ? window.innerHeight : 0) || 800) {
  return Math.max(minPx, Math.round(viewportH * MAX_VIEWPORT_SHARE));
}

export function autoGrow(el, minPx = EDIT_MIN_PX, maxPx = null) {
  if (!el) return 0;
  const max = maxPx == null ? maxGrowPx(minPx) : Math.max(minPx, maxPx);
  el.style.height = "auto";
  const content = el.scrollHeight || 0;
  const h = Math.min(Math.max(content, minPx), max);
  el.style.height = `${h}px`;
  el.style.overflowY = content > max ? "auto" : "hidden";
  return h;
}
